import React from 'react';

const EditResource = React.lazy(() => import('./EditResource'));
const CreateResource = React.lazy(() => import('./CreateResource'));
const DuplicateResource = React.lazy(() => import('./DuplicateResource'));
const ConfigureResources = React.lazy(() => import('./ConfigureResources'));

export { EditResource, CreateResource, DuplicateResource, ConfigureResources };
